export interface UserProps {
  sub: string;
  email: string;
  firstName: string;
  lastName: string;
  avatar?: string | null;
}

export class User {
  private readonly _sub: string;
  private readonly _email: string;
  private readonly _firstName: string;
  private readonly _lastName: string;
  private readonly _avatar?: string | null;

  constructor(props: UserProps) {
    this._sub = props.sub;
    this._email = props.email;
    this._firstName = props.firstName;
    this._lastName = props.lastName;
    this._avatar = props.avatar;
  }

  get sub(): string {
    return this._sub;
  }

  get email(): string {
    return this._email;
  }

  get firstName(): string {
    return this._firstName;
  }

  get lastName(): string {
    return this._lastName;
  }

  get fullName(): string {
    return `${this._firstName} ${this._lastName}`;
  }

  get avatar(): string | null | undefined {
    return this._avatar;
  }
}
